import { Form, Input, message, Modal } from "antd";
import { useCreateFolder } from "../../utils/queryUtils";
import { useDispatch } from "react-redux";
import { setReloadFolder, } from "../../store/action/reload";
import { useState } from "react";
export default function CreateDocument({ open, setOpen, fy_id }) {
    const [form] = Form.useForm();
    const [page] = useState(1);
    const { mutateAsync: createFolder, isSuccess: createFolderSuccess } = useCreateFolder();
    const dispatch = useDispatch();
    const submit = async (value) => {
        if (value.name === "") {
            message('Please Fill Properly')
        }
        let body = {
            name: value.name,
            fy_id,
            page,
        }
        try {
            let res = await createFolder(body);
            if (res) {
                message.success("Folder Created");
                form.resetFields();
                dispatch(setReloadFolder(true));
            }
            setOpen(false);
        }
        catch (e) {
            console.error(e);
            form.resetFields();
            setOpen(false);
        }
    }
    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            okText="Submit"
            destroyOnClose
            title="Submit New Documents"
            onOk={form.submit}
        >
            <Form form={form}
                onFinish={submit}>
                <Form.Item name="name"
                    label="Create Folder"
                >
                    <Input />
                </Form.Item>
            </Form>

        </Modal>
    )
}